// Updated ConnectCard.tsx
import React from "react";
import { IonIcon } from "@ionic/react";

// Define the props interface with strict types and parallax props
interface ConnectCardProps {
  id?: string;
  title: string;
  description: string;
  buttonText: string;
  icon?: string;
  onButtonClick: (id: string) => void;
  className?: string;
  scrollProgress?: number;
  index?: number;
}

/**
 * ConnectCard Component - Individual floating card with parallax effects
 */
const ConnectCard: React.FC<ConnectCardProps> = ({
  id,
  title,
  description,
  buttonText,
  icon,
  onButtonClick,
  className = "",
  scrollProgress = 0,
  index = 0,
}) => {
  // Calculate parallax offset based on scroll and card position
  const parallaxOffset = scrollProgress * (index - 1) * 0.1;
  const scaleValue = Math.max(0.95, 1 - Math.abs(parallaxOffset) * 0.1);
  const opacity = Math.max(0.8, 1 - Math.abs(parallaxOffset) * 0.3);

  return (
    <div
      className={`connect-card ${className}`}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "30px",
        gap: "10px",
        background: "#FFFFFF",
        boxShadow: `0px 0px ${
          20 + Math.abs(parallaxOffset) * 10
        }px rgba(58, 40, 80, ${0.2 + Math.abs(parallaxOffset) * 0.1})`,
        borderRadius: "15px",
        fontFamily: "Figtree",
        minWidth: "280px",
        maxWidth: "100%",
        flexShrink: 0,
        transform: `translateY(${parallaxOffset * 20}px) scale(${scaleValue})`,
        opacity: opacity,
        transition: "all 0.3s ease",
        margin: "8px 0",
      }}
    >
      {/* Card Title */}
      <h2
        style={{
          fontSize: "20px",
          fontWeight: "600",
          margin: "0",
          textAlign: "center",
        }}
      >
        {title}
      </h2>

      {/* Card Description */}
      <p
        style={{
          fontFamily: "Figtree",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: "17px",
          lineHeight: "22px",
          textAlign: "center",
          fontFeatureSettings: "'case' on",
          color: "#000000",
          alignSelf: "stretch",
          margin: "0",
        }}
      >
        {description}
      </p>

      {/* Action Button */}
      {buttonText && (
        <button
          onClick={() => onButtonClick(id || "")}
          style={{
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 25px",
            gap: "5px",
            background: "#05ACD9",
            border: "1px solid #05ACD9",
            borderRadius: "30px",
            color: "white",
            fontSize: "16px",
            fontWeight: "500",
            cursor: "pointer",
            flex: "none",
            marginTop: "8px",
          }}
        >
          {icon && <IonIcon icon={icon} style={{ marginRight: "5px" }} />}
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default ConnectCard;
